<section class="contactanos">
	<div class="contactanos-titulo">
		<img src="assets/images/banners/contacto.jpg" alt="Contacto" loading="lazy"/>
	</div>
	<section>
		<div class="contactanos-formulario">
			<h1>Contacto</h1>	
			<div class="control">
				<label>Nombre</label>
				<input type="text" placeholder="Nombre" [(ngModel)]="contacto.nombre">
			</div>
			<div class="control">
				<label>Teléfono</label>
				<input type="text" placeholder="Teléfono" [(ngModel)]="contacto.telefono">
			</div>
			<div class="control">
				<label>Correo Electrónico</label>
				<input type="text" placeholder="Correo Electrónico" [(ngModel)]="contacto.correo">
			</div>
			<div class="control">
				<label>Escribe tu mensaje, duda o pregunta, con gusto te atenderemos</label>
				<textarea rows="10" placeholder="Escribe tu mensaje" [(ngModel)]="contacto.descripcion"></textarea>
			</div>
			<div class="control-btn col5">
				<button class="fondo-purple" (click)="fnValidarFormulario()">Enviar mensaje</button>
			</div>
			<br>
			<div class="control">
				<b>o Escribenos al WhatsApp <small>(solo mensaje)</small>:</b>
			</div>
			<div class="control-btn col5">
				<a class="btnWhatsApp" href="http://ivt.mx/e7XFv" target="_blank">
					<span><i class="fab fa-whatsapp fa-2x"></i></span>
					<span>(56) 2165 6563</span>
				</a>
			</div>
		</div>
		<div class="contactanos-sucursales">
			<h1>Sucursales</h1>
			<section *ngFor="let newItem of listaSucursales">
				<figure>
					<img *ngIf=" newItem.fotografia.length > 0 " [src]="newItem.fotografia[0].base64" alt="{{ newItem.nombre }}" loading="lazy"/>
				</figure>
				<figcaption>
					<div><h1 class="color-purple">{{ newItem.nombre }}</h1></div>
					<div><p>{{ newItem.direccion }}</p></div>
					<div><p [innerHTML]="newItem.horarios"></p></div>
					<div>
						<p>
							<span [innerHtml]=" newItem.telefonos | safe:'html' "></span>
							<span class="color-white">Uriel</span>
							<span [innerHtml]=" newItem.whatsapp | safe:'html' "></span>
						</p>
					</div>
				</figcaption>
			</section>
		</div>
	</section>
</section>